export const HELP_DRAWER_VIEW = {
  MENU: 'menu',
  FEEDBACK: 'feedback',
} as const
